App.namespace.wrap('es6.shared.preload', (pages = []) => {
  const ASSETS_DIR = '/build';
  const REV_MANIFEST = '/build/rev-manifest.json';

  const storageManager = App.es6.shared.storage_manager().init('session');

  const fix = assets => assets.map(path => path.replace(/\|/g, '/'));

  // Note: Laravel elixir auto-magically replaces these below with real paths like:
  // `/build/css/pages/hire-171e84ae9e.css`
  // during gulp version task, so I use pipes to prevent it
  const PAGES = {
    search: fix([
      'vite|misc|common.css',
      'js|shared-vendors.js',
      'js|search-vendors.js',
      'css|landing.css',
      'vite|search.css',
      'vite|search.js',
    ]),
    room: fix([
      'vite|misc|common.css',
      'js|shared-vendors.js',
      'css|landing.css',
      'vite|room.css',
      'vite|room.js',
    ]),
  };

  const isFontAsset = (asset) => {
    return /\.woff2?$/.test(asset);
  }

  const getPreloadAsAttribute = (asset) => {
    if (/\.css$/.test(asset)) {
      return 'style';
    }
    if (/\.js$/.test(asset)) {
      return 'script';
    }

    if (isFontAsset(asset)) {
      return 'font';
    }

    return null;
  };

  const createPreloadLink = (asset) => {
    const s = document.createElement('link');
    s.rel = 'preload';
    s.href = `${ASSETS_DIR}/${asset}`;
    s.as = getPreloadAsAttribute(asset);
    document.querySelector('head').appendChild(s);
  };

  const alreadyCached = url => {
    return storageManager.get(`TV_PRELOAD__${url}`) === '1';
  };

  const saveAsCached = url => {
    storageManager.set(`TV_PRELOAD__${url}`, '1');
  };

  const preloadFromManifest = revManifest => {
    pages.forEach(page => {
      if (!PAGES[page]) {
        return;
      }
      PAGES[page].forEach(asset => {
        if (isFontAsset(asset)) {
          createPreloadLink(asset);
          saveAsCached(asset);
          return;
        }

        if (revManifest && revManifest[asset] && !alreadyCached(revManifest[asset])) {
          createPreloadLink(revManifest[asset]);
          saveAsCached(revManifest[asset]);
        }
      });
    });
  };

  const init = () => {
    $.ajax({
      type: 'GET',
      dataType: 'json',
      url: REV_MANIFEST,
    }).then((response) => {
      preloadFromManifest(response);
    });
  };

  // preload future assets after save time after onload event
  // to make sure we don't slow down anything more important
  window.addEventListener('load', () => setTimeout(init, 2000));
});
